'use strict';

const SELECTOR = '.youtubeThumbnail';

function setYouTubeThumbnails(selector) {
    const thumbnails = document.querySelectorAll(selector);

    thumbnails.forEach(thumbnail => {
        const youtubeUrl = thumbnail.getAttribute('data-youtube-url');

        if (youtubeUrl) {
            const embedId = getYouTubeEmbedId(youtubeUrl);
            if (embedId) {
                thumbnail.src = `https://img.youtube.com/vi/${embedId}/sddefault.jpg`;
            }
        }
    });
}

function getYouTubeEmbedId(url) {
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S+\/\S+\/|\S+\?v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
}

export function init() {
    if (document.querySelector(SELECTOR)) {
        setYouTubeThumbnails(SELECTOR);
    }
}


